import React from 'react';
import { string, func } from 'prop-types';

export default function ModalCloseConfirmation(props) {
    const { message, confirmTitle, confirmHandler, cancelTitle, cancelHandler, className } = props;
    const wrapperClass = className ? `modal-close-confirmation-mask ${className}` : 'modal-close-confirmation-mask';

    return (
        <div className={wrapperClass}>
            <div className="modal-close-confirmation">
                <div className="modal-close-confirmation-message">
                    {message}
                </div>
                <button className="modal-close-confirmation-button btn-error" onClick={confirmHandler}>{confirmTitle}</button>
                <button className="modal-close-confirmation-button btn-approve" onClick={cancelHandler}>{cancelTitle}</button>
            </div>
        </div>
    );
}

ModalCloseConfirmation.propTypes = {
    message: string.isRequired,
    confirmTitle: string,
    confirmHandler: func.isRequired,
    cancelTitle: string,
    cancelHandler: func.isRequired,
    className: string
};

ModalCloseConfirmation.defaultProps = {
    className: '',
    confirmTitle: 'Yes',
    cancelTitle: 'No'
};
